<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">About us</TextHeading>
      <TextHeading variant="xl">Board Members’ Biographies</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
      </PageSide>
      <PageMain>
        <GridRow cols="2">
          <GridCol>
            <CardLink
              title="David Potts"
              role="Chief Executive Officer"
              category="Board Members’ Biographies"
            ></CardLink>
          </GridCol>
          <GridCol>
            <CardLink
              title="David Potts"
              role="Chief Executive Officer"
              category="Board Members’ Biographies"
            ></CardLink>
          </GridCol>
          <GridCol>
            <CardLink
              title="David Potts"
              role="Chief Executive Officer"
              category="Board Members’ Biographies"
            ></CardLink>
          </GridCol>
          <GridCol>
            <CardLink
              ttitle="David Potts"
              role="Chief Executive Officer"
              category="Board Members’ Biographies"
            ></CardLink>
          </GridCol>
          <GridCol>
            <CardLink
              title="David Potts"
              role="Chief Executive Officer"
              category="Board Members’ Biographies"
            ></CardLink>
          </GridCol>
          <GridCol>
            <CardLink
              title="David Potts"
              role="Chief Executive Officer"
              category="Board Members’ Biographies"
            ></CardLink>
          </GridCol>
        </GridRow>
        <RelatedInformation/>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import RelatedInformation from '../components/RelatedInformation.vue'
import CardLink from '../components/CardLink.vue'
import GridCol from '../elements/GridCol.vue'
import GridRow from '../elements/GridRow.vue'
import PageMain from '../elements/PageMain.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PageAboutUs',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    PageMain,
    GridRow,
    GridCol,
    CardLink,
    RelatedInformation,
    TheFooter
  },
  data() {
    return {
      items: [
        {
          title: 'Christmas Trading Statement',
          type: 'Download PDF'
        },
        {
          title: 'Q3 Trading Statement',
          type: 'Download PDF'
        },
        {
          title: 'Q2 Trading Statement',
          type: 'Download PDF'
        }
      ]
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>